export default () => {
  return localStorage.getItem('settings');
};
